import { useEffect, useState } from "react";
import { Sidebar } from "../components/sidebar";
import { useDispatch, useSelector } from "react-redux";
import { getConversations, updateMessagesAndConversations } from "../features/chatSlice";
import { ChatContainer, WhatsappHome } from "../components/chat";
import { useAdminSocket } from "../context/AdminSocketContext";
import { useLocation } from "react-router-dom";
import DashboardPage from "./app/DashboardPage";
import UsersPage from "./app/UsersPage";
import PlatformPagesPage from "./app/PlatformPagesPage";
import SettingsPage from "./app/SettingsPage";
function Home(){

    const dispatch = useDispatch();
    const {user} = useSelector((state)=> state.user)
    const {activeConversation} = useSelector((state)=>state.chat);
    const { socket } = useAdminSocket();
    const location = useLocation();
    const [onlineUsers,setOnlineUsers] = useState([]);
    const [typing, setTyping] = useState(false);
    const isInboxRoute = location.pathname.startsWith('/app/inbox');

    const renderRightPanel = () => {
        if (location.pathname.startsWith('/app/dashboard')) return <DashboardPage />;
        if (location.pathname.startsWith('/app/users')) return <UsersPage />;
        if (location.pathname.startsWith('/app/platform-pages')) return <PlatformPagesPage />;
        if (location.pathname.startsWith('/app/settings')) return <SettingsPage />;
        return activeConversation._id ? <ChatContainer onlineUsers={onlineUsers} typing={typing} /> : <WhatsappHome />;
    };

    useEffect(()=>{
        if(user?.token){
            dispatch(getConversations(user.token));
        }
    },[user]);

    useEffect(()=>{
        if (!socket) return;
        const onAdminMessage = (payload) => {
            dispatch(updateMessagesAndConversations({ ...payload, adminUser: user, activeConversation }));
            if (user?.token) {
                dispatch(getConversations(user.token));
            }
        };
        socket.on("admin:message:new", onAdminMessage);
        return () => {
            socket.off("admin:message:new", onAdminMessage);
        };
    }, [socket, user?.token, user, activeConversation]);

    return(
        <>
            <div className="h-screen dark:bg-dark_bg_1 flex items-center
            justify-center overflow-hidden">

                <div className="w-full h-screen flex min-w-0 overflow-x-hidden">
                    {/* Sidebar */}
                    <Sidebar onlineUsers={onlineUsers} typing={typing} />
                    <div className="flex-1 min-w-0 flex">
                    {isInboxRoute ? (
                        activeConversation._id ? <ChatContainer onlineUsers={onlineUsers} typing={typing} /> : <WhatsappHome/>
                    ) : renderRightPanel()}
                    </div>
                </div>

            </div>

        </>
    )

}
export default Home;